import moment from 'moment';
import React, { useState } from 'react';
import { Tag } from '@gerdau/hefesto/Tag';

enum EDeliveryStatus {
  NOT_CONFIRMED = 'not_confirmed',
  ON_TIME = 'on_time',
  OVERDUE = 'overdue'
}

interface IDeliveryStatus {
  status: EDeliveryStatus;
  description: string;
  variantStatus: string;
}

interface IDeliveryStatusColumnProps {
  estimatedDeliveryDate?: string;
}

const DeliveryStatusColumn: React.FC<IDeliveryStatusColumnProps> = ({
  estimatedDeliveryDate
}) => {
  const getDeliveryStatus = (): IDeliveryStatus => {
    if (!estimatedDeliveryDate) {
      return {
        status: EDeliveryStatus.NOT_CONFIRMED,
        description: 'Não confirmado',
        variantStatus: 'warning'
      };
    }

    const today = moment();
    let deliveryDate;

    if (estimatedDeliveryDate.length > 10) {
      // caso retorne no formato "DD/MM/YYYY à DD/MM/YYYY"
      const splitedDate = estimatedDeliveryDate.split(' ');
      deliveryDate = moment(splitedDate[splitedDate.length - 1], 'DD/MM/YYYY');
    } else {
      deliveryDate = moment(estimatedDeliveryDate, 'DD/MM/YYYY');
    }

    if (today.isSameOrBefore(deliveryDate)) {
      return {
        status: EDeliveryStatus.ON_TIME,
        description: 'Dentro do prazo',
        variantStatus: 'primary'
      };
    } else {
      return {
        status: EDeliveryStatus.OVERDUE,
        description: 'Em atraso',
        variantStatus: 'danger'
      };
    }
  };

  const [deliveryStatus] = useState(getDeliveryStatus());

  return (
    <Tag variant={deliveryStatus.variantStatus}>
      {deliveryStatus.description}
    </Tag>
  );
};

export default DeliveryStatusColumn;
